import { db } from "firebase/fbConfig.js"

// Get Users for Users Panel
export function listenToUsersForUser(store, uid) {
  return db.collection("users").onSnapshot(
    (snapshot) => {
      snapshot.docChanges().forEach((change) => {
        const data = change.doc.data();
        const id = change.doc.id;
        switch (change.type) {
          case 'added':
            store.dispatch(addUser(id, data));
            break;
          case 'modified':
            store.dispatch(modifyUser(id, data));
            break;
          case 'removed' :
            store.dispatch(removeUser(id));
            break;
          default:
            console.warn("Uknown change type", change.type);
            break;
        }
      })
    }
  )
}

export function startSetUser(uid, listeners) {
  return dispatch => {
    return db
      .collection('users')
      .doc(uid)
      .get()
      .then(snapshot => {
        dispatch(setUser({ ...snapshot.data(), id: uid }, listeners));
      })
  }
}

export function startUpdateUser(uid, data) {
  console.log("startUpdateUser>>>", uid, data)
  return dispatch => {
    return db
      .collection('users')
      .doc(uid)
      .set(data, { merge: true });
  }
}

export function addUser(id, data) {
  return {
    type: 'USERS_ADD',
    data,
    id
  }
}

export function addUserListener(id, listener) {
  return {
    type: 'USERS_ADD_LISTENER',
    id,
    listener
  }
}

export function modifyUser(id, data) {
  return {
    type: 'USERS_MODIFY',
    data,
    id
  }
}

export function removeUser(id) {
  return {
    type: 'USERS_REMOVE',
    id
  }
}

export function setUser(data, listeners) {
  return {
    type: 'USERS_SET_USER',
    data,
    listeners
  }
}

// export const photoDialogSave = (url) => {
//   console.log('profile actions url', url)
//   return {
//     type: 'PROFILE_PHOTO_DIALOG_SAVE',
//     url: url
//   }
// };